const _ = require("lodash");

export const getVariant = (state, campaignCode) => {
  return _.get(state, `rlab.variants.${campaignCode}`, "");
};

export const generatingVariants = state => {
  return _.get(state, "rlab.generating", false);
};

/**
 * True when the campaign was allocated on the most recent variants request, i.e.
 * the loan was just placed into its variant rather than already being in it.
 */
export const wasNewlyGenerated = (state, campaignCode) => {
  return _.get(state, "rlab.newlyGenerated", []).includes(campaignCode);
};
